<div mat-dialog-title class="dialog-header">
    <h5>Node History</h5>
    <nb-icon mat-dialog-close icon="close-outline"></nb-icon>
</div>
<mat-dialog-content>
    <mat-tab-group>
        <mat-tab label="Commission/Decommission">
            <div class="loader" *ngIf="loading">
                <div>
                    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                </div>
            </div>
            <div *ngIf="dataSourceForComDcom.length">
                <table mat-table [dataSource]="dataSourceForComDcom" class="mat-elevation-z8">
                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef> Type </th>
                        <td mat-cell *matCellDef="let element"> {{element.type}} </td>
                    </ng-container>
                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef> Date </th>
                        <td mat-cell *matCellDef="let element"> {{element.date!=="NA"? (element.date | date:'medium'):element.date}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsForComDcom"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsForComDcom;"></tr>
                </table>
            </div>
            <div *ngIf="loading==false && !dataSourceForComDcom.length" class="nothing">
                <div><p>There was no Commission/Decommission record found for this node.</p></div>
            </div>
        </mat-tab>
        <mat-tab label="Replacement">
            <div class="loader" *ngIf="loadingReplacement">
                <div>
                    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                </div>
            </div>
            <div *ngIf="dataSourceForReplacement.length">
                <table mat-table [dataSource]="dataSourceForReplacement" class="mat-elevation-z8">
                    <ng-container matColumnDef="oldEid">
                        <th mat-header-cell *matHeaderCellDef> Old eID </th>
                        <td mat-cell *matCellDef="let element"> {{element.oldEid}}({{element.oldNodeShortId}}) </td>
                    </ng-container>
                    <ng-container matColumnDef="newEid">
                        <th mat-header-cell *matHeaderCellDef> New eID </th>
                        <td mat-cell *matCellDef="let element"> {{element.newEid}}({{element.newNodeShortId}}) </td>
                    </ng-container>
                    <ng-container matColumnDef="invokerId">
                        <th mat-header-cell *matHeaderCellDef> Done By </th>
                        <td mat-cell *matCellDef="let element"> {{element.invokerId}} </td>
                    </ng-container>
                    <ng-container matColumnDef="reason">
                        <th mat-header-cell *matHeaderCellDef> Reason </th>
                        <td mat-cell *matCellDef="let element"> {{element.reason}} </td>
                    </ng-container>
                    <ng-container matColumnDef="customerEmail">
                        <th mat-header-cell *matHeaderCellDef> Customer Email ID </th>
                        <td mat-cell *matCellDef="let element"> {{element.customerEmail}} </td>
                    </ng-container>
                    <ng-container matColumnDef="initiationDate">
                        <th mat-header-cell *matHeaderCellDef>Initiation Date </th>
                        <td mat-cell *matCellDef="let element"> {{element.initiationDate != undefined ? (element.initiationDate | date:'medium'):element.initiationDate}} </td>
                    </ng-container>
                    <ng-container matColumnDef="completionDate">
                        <th mat-header-cell *matHeaderCellDef>Completion Date </th>
                        <td mat-cell *matCellDef="let element"> {{element.completionDate !==undefined ? (element.completionDate | date:'medium'):element.completionDate}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsForReplacement"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsForReplacement;"></tr>
                </table>
            </div>
            <div *ngIf="loadingReplacement==false && !dataSourceForReplacement.length" class="nothing">
                <div><p>There was no Replacement record found for this node.</p></div>
            </div>
        </mat-tab>
        <mat-tab label="Delay Modify">
            <div class="loader" *ngIf="loadingDelayModify">
                <div>
                    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                </div>
            </div>
            <div *ngIf="dataSourceForDelayModify.length">
                <table mat-table [dataSource]="dataSourceForDelayModify" class="mat-elevation-z8">
                    <ng-container matColumnDef="invokerId">
                        <th mat-header-cell *matHeaderCellDef> Invoked By </th>
                        <td mat-cell *matCellDef="let element"> {{element.invokerId}}</td>
                    </ng-container>
                    <ng-container matColumnDef="reason">
                        <th mat-header-cell *matHeaderCellDef> Reason </th>
                        <td mat-cell *matCellDef="let element"> {{element.reason}}</td>
                    </ng-container>
                    <ng-container matColumnDef="time">
                        <th mat-header-cell *matHeaderCellDef> Modified Time (in HEX) </th>
                        <td mat-cell *matCellDef="let element"> {{element.time}} </td>
                    </ng-container>
                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef>Date </th>
                        <td mat-cell *matCellDef="let element"> {{element.date != undefined ? (element.date | date:'medium'):element.date}} </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>Status </th>
                        <td mat-cell *matCellDef="let element"> {{element.status == undefined ? "UNKNOWN" : element.status}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsForDelayModify"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsForDelayModify;"></tr>
                </table>
            </div>
            <div *ngIf="loadingReplacement==false && !dataSourceForDelayModify.length" class="nothing">
                <div><p>There was no Delay Modification record found for this node.</p></div>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>